@if (content.title && display) {
  <div [id]="content.id" class="skymiles-landing-page-micro-moments">
    <aura-micro-moments
      [content]="content"
      (dismiss)="dismiss()"
      (redirect)="redirect($event)"
    ></aura-micro-moments>
  </div>
}
